export default __webpack_public_path__ + "static/media/arritmias.2f2aef57.pdf";